export type Role = "pending" | "parent" | "committee" | "teacher" | "admin";

export const ROLE_LABEL: Record<Role, string> = {
  pending: "Очікує підтвердження",
  parent: "Батьки",
  committee: "Голова комітету",
  teacher: "Класний керівник",
  admin: "Адміністратор",
};

export const PARENT_ROLES: Role[] = ["parent", "committee"];

export function isStaff(role: Role): boolean {
  return role === "teacher" || role === "admin";
}

export function isAdmin(role: Role): boolean {
  return role === "admin";
}

export function isParentRole(role: Role): boolean {
  return role === "parent" || role === "committee";
}

export function canSeeAllPhones(role: Role): boolean {
  return isStaff(role) || role === "committee";
}

export function canLinkChildren(role: Role): boolean {
  return isParentRole(role) || role === "admin";
}

export function canCreatePoll(role: Role): boolean {
  return isParentRole(role) || role === "teacher" || role === "admin";
}

export function canSeeSecretPolls(role: Role): boolean {
  return isParentRole(role) || role === "admin";
}

export function canCreateSecretPoll(role: Role): boolean {
  return canSeeSecretPolls(role);
}

export function canManagePoll(
  role: Role,
  secret: boolean,
  createdById?: string,
  userId?: string,
): boolean {
  const isCreator = Boolean(createdById && userId && createdById === userId);
  if (secret) return role === "admin" || (isCreator && role !== "teacher");
  return isStaff(role) || isCreator;
}

export function canCreateCollection(role: Role): boolean {
  return canCreatePoll(role);
}

export function canManageCollection(role: Role, createdById?: string, userId?: string): boolean {
  const isCreator = Boolean(createdById && userId && createdById === userId);
  return isStaff(role) || role === "committee" || isCreator;
}

export function parseIdList(value: string | undefined | null): string[] {
  if (!value) return [];
  return value
    .split(/[,\s]+/)
    .map((item) => item.trim())
    .filter(Boolean);
}

export function normalizeUsername(value: string | undefined | null): string | null {
  if (!value) return null;
  const trimmed = value.trim().replace(/^@/, "").toLowerCase();
  return trimmed || null;
}

export function isConfiguredAdmin(telegramId: string, username?: string | null): boolean {
  const listed = parseIdList(process.env.ADMIN_TELEGRAM_IDS);
  const uname = normalizeUsername(username);
  for (const item of listed) {
    const value = item.replace(/^@/, "").toLowerCase();
    if (value === telegramId.toLowerCase()) return true;
    if (uname && value === uname) return true;
  }
  return false;
}

export function isAssignedRole(role: string): role is Role {
  return role === "pending" || role === "parent" || role === "committee" || role === "teacher" || role === "admin";
}
